<accordion class="sessions-list">
    @for (session of form.controls.items["controls"]; track session) {
        <accordion-group
            hznTestId="session-panel"
            [heading]="session.controls.basicInfo.controls.name.value"
            [isOpen]="session.controls.isOpen.value"
            (isOpenChange)="isOpenChanged($event, session)"
            panelClass="panelClass"
        >
            @if (session.controls.isOpen.value) {
                <app-session-details
                    hznTestId="session-details"
                    [form]="session"
                    [context]="context"
                ></app-session-details>
            }
        </accordion-group>
    }
</accordion>
